<template>
  <exercicioPergunta :alternativas="alternativas"></exercicioPergunta>
</template>

<script>
import exercicioPergunta from '@/custom/exercicioPergunta'
var componentData = {
  alternativas: [
    {
      resposta: 1,
      icon: 'check',
      title: 'Verdadeiro'
    },
    {
      resposta: 2,
      icon: 'cancel',
      title: 'Falso'
    }
  ]
}
var componentDefinition = {
  components: { exercicioPergunta },
  route: {
    name: 'ASSERTIVAS-PERGUNTA',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/assertivas/rodada/:rodada/pergunta/:refresh?',
    meta: {
      title: 'Verdadeiro ou Falso',
      hasErrorHandler: true,
      pergunta: true,
      hidden: true
    }
  },
  data: function () {
    return componentData
  }
}
export default componentDefinition
</script>
